import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputNotAnEuroDateErrorMessage = (
  <Trans>
    Ce champ doit contenir une date au format JJ/MM/AAAA
  </Trans>
);
